import { createSelector } from "@reduxjs/toolkit";
import selectWorkoutsRaw from "./selectWorkoutsRaw";

export default createSelector(selectWorkoutsRaw, ({ selectedWorkout }) => selectedWorkout);
